var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from '../elements/svg-circle-icon';
export var OrganisationTypeIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 58,
    glyphHeight: 71,
    glyphOffsetY: 4
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6744 70.9242V67.1309H18.1828V69.7011C20.2838 70.2774 22.4525 70.69 24.6744 70.9242ZM9.52746 66.2127V48.7499H48.4767V66.2128C51.6378 64.4928 54.5462 62.3671 57.1321 59.9056V40.0945H0.87207V59.9054C3.45791 62.3669 6.36635 64.4926 9.52746 66.2127ZM39.8213 69.7012V67.1309H33.3298V70.9242C35.5516 70.69 37.7203 70.2775 39.8213 69.7012ZM18.1827 56.3116H24.6742V62.8031H18.1827V56.3116ZM39.8211 56.3116H33.3296V62.8031H39.8211V56.3116Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M29.0019 0.67627C19.653 0.67627 12.0039 8.32538 12.0039 17.6743C12.0039 27.0232 19.653 34.6723 29.0019 34.6723C38.3509 34.6723 46 27.0232 46 17.6743C46 8.32538 38.3509 0.67627 29.0019 0.67627ZM26.1689 26.1733L17.6699 17.6743L20.5029 14.8413L26.1689 20.5073L37.501 9.17528L40.334 12.0083L26.1689 26.1733Z",
    fill: "black"
  }));
};
export var OrganisationTypeIconGlyph = function (props) {
  return React.createElement(OrganisationTypeIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};